import { render, staticRenderFns } from "./AvailableAccounts.vue?vue&type=template&id=228f1c73&"
import script from "./AvailableAccounts.vue?vue&type=script&lang=js&"
export * from "./AvailableAccounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports